export * from './src/dynamic-result-table';
